<template>
  <div>
    <el-row class="movie-list">
      <h2>联系人</h2>
      <el-button
        size="mini"
        @click="onSearchUser"
      >查找用户</el-button>
    </el-row>
    <el-row class="movie-list">
      <el-col :md="12">
        <el-card>
          <el-table
            :data="dataList"
            :show-header="true"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="avatarUrl"
              label="头像"
              width="90"
            >
              <template slot-scope="scope">
                <el-image :src="scope.row.avatarUrl" min-width="30" height="20" />
              </template>
            </el-table-column>
            <el-table-column
              prop="username"
              label="名字"
            />
            <el-table-column
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="viewContact(scope.row)"
                >详情</el-button>
                <el-button
                  size="mini"
                  @click="deleteContact(scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
      title="查找用户"
      :visible.sync="searchUserDialog"
      @close="onCloseDialog"
    >
      <div>
        <el-row style="padding: 5px">
          <el-select v-model="queryForm.searchType" placeholder="选择查找类型">
            <el-option label="手机号" value="1" />
            <el-option label="用户名" value="2" />
          </el-select>
          <el-input
            v-model="queryForm.searchValue"
            placeholder="查找用户"
            style="width: 30%; padding-left: 5px"
            clearable
            @keyup.enter.native="searchUser"
          >
            <el-button slot="append" icon="el-icon-search" @click="searchUser" />
          </el-input>
        </el-row>
        <el-row style="padding: 5px">
          <el-table
            :data="searchUserList"
            :show-header="true"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="avatarUrl"
              label="头像"
              width="90"
            >
              <template slot-scope="scope">
                <el-image :src="scope.row.avatarUrl" min-width="30" height="20" />
              </template>
            </el-table-column>
            <el-table-column
              prop="username"
              label="名字"
            />
            <el-table-column
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="addUser(scope.row)"
                >添加</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserContact, searchUser } from '@/api/user'

export default {
  name: 'MyContact',
  data() {
    return {
      dataList: [],
      searchUserDialog: false,
      searchUserList: [],
      queryForm: {
        searchType: '1',
        searchValue: null
      }
    }
  },
  created() {
    document.title = '我的联系人'
    this.getData()
  },
  methods: {
    getData() {
      getUserContact(1).then(resp => {
        if (resp.code === 0) {
          this.dataList = resp.data
        } else {
          this.$message.error(resp.msg)
        }
      })
    },
    viewContact(row) {
      this.$message.info('get ' + row.username + ' detail')
    },
    deleteContact(row) {
      this.$message.info('delete contact ' + row.username)
    },
    onSearchUser() {
      this.searchUserDialog = true
    },
    searchUser() {
      searchUser(this.queryForm).then(resp => {
        if (resp.code === 0) {
          this.searchUserList = resp.data
        } else {
          this.$message.error(resp.msg)
        }
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    addUser(row) {
      this.$message.info('add user')
    },
    onCloseDialog() {
      this.searchUserDialog = false
    }
  }
}
</script>

<style scoped>
/*处于手机屏幕时*/
@media screen and (max-width: 768px) {
  .movie-list {
    padding-top: 8px;
    padding-left: 0.5%;
    padding-right: 0.5%;
  }
}

.movie-list {
  padding-top: 15px;
  padding-left: 6%;
  padding-right: 6%;
}
</style>
